module.exports = __webpack_public_path__ + "static/media/downloadQR.11aad978.png";